import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_ACQUISITO_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolAcquisitiKoState extends EntityState<IID_OL_ACQUISITO_KO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_ACQUISITO_KO })
@InterfaceDataStore(InterfaceName.ACQUISIZIONE_NEGATIVA)
export class IIDolAcquisitiKoStore extends EntityStore<IIDolAcquisitiKoState> {
  constructor() {
    super([]);
  }
}
